import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import QuickbooksContainer from "../../containers/accounting/Quickbooks";
import {gridMargin} from "./general";


class FMPQuickbooksAccountSelect extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		const {quickbooksAccounts, searchQuickbooksAccounts} = this.props;
		if (_.isEmpty(quickbooksAccounts)) {
			searchQuickbooksAccounts({
				params : {}
			});
		}
	}

	render () {
		const {
			label, value, path, onChange,
			error, helpText, md, readOnly,
			quickbooksAccounts,
		} = this.props;

		if (!quickbooksAccounts) {
			return (<Grid spacing={2} container>
				<Grid item xs={12} md={md}>
					<Select
						value={value}
						input={<Input id={path} readOnly={readOnly} />}
					>
						<MenuItem key={'loading_quickbooks_accounts'} value={'loading'} disabled>
							Loading accounts from quickbooks...
						</MenuItem>
					</Select>
				</Grid>
			</Grid>);
		}


		const quickbooksAccountOptions = quickbooksAccounts.reduce((result, quickbooksAccount) => {
			const { Classification, quickbooksAccountId, Name, ParentRef} = quickbooksAccount;
			if (Classification !== 'Expense') { return result; }

			let display = Name;
			if (ParentRef) {
				display = (<div style={{paddingLeft:20}}>{Name}</div>);
			}

			result.push({
				value : quickbooksAccountId,
				display,
			});
			return result;
		}, []);

		const hasError = !!error;
		const _onChange = event => {
			onChange(event.target.value, path);
		};

		return (<Grid spacing={2} container >
			<Grid item xs={12} md={md} style={gridMargin}>
				<FormControl fullWidth={true} error={hasError}>
					<InputLabel htmlFor={path}>{label}</InputLabel>
					<Select
						value={value}
						onChange={_onChange}
						input={<Input id={path} readOnly={readOnly} />}
					>
						{quickbooksAccountOptions.map(quickbooksAccountOption => {
							const { display, value } = quickbooksAccountOption;
							return (
								<MenuItem key={value} value={value}>
									{display}
								</MenuItem>
							);
						})}
					</Select>
					{hasError && <FormHelperText>{error}</FormHelperText>}
					{(helpText && !hasError) && <FormHelperText>{helpText}</FormHelperText>}
				</FormControl>
			</Grid>
		</Grid>);
	}
}

FMPQuickbooksAccountSelect.propTypes = {
	label : PropTypes.string,
	value :	PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	error : PropTypes.string,

	searchQuickbooksAccounts : PropTypes.func,
	quickbooksAccounts : PropTypes.array,

	md : PropTypes.number,
	helpText : PropTypes.string,
	readOnly : PropTypes.bool,
};

FMPQuickbooksAccountSelect.defaultProps =  {
	helpText : 'Only showing accounts marked as an "Expense"'
};

export default _.flow([
	QuickbooksContainer,
])(FMPQuickbooksAccountSelect);
